import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { Layout } from '@storable/canaveral-components';
import { AdminLayout, AdminHeader } from '..';

const { Navbar } = Layout;

const propTypes = {
  activeItem: PropTypes.string,
  children: PropTypes.node,
  title: PropTypes.string,
};

const defaultProps = {
  activeItem: undefined,
};

const Hyper = ({
  activeItem,
  children,
  title,
}) => {
  const header = (
    <AdminHeader title={title} />
  );

  const items = {
    dashboard: {
      icon: 'analytics',
      to: '/admin/hyper',
      componentClass: Link,
      text: 'Dashboard',
    },
    websites: {
      icon: 'conference-center',
      to: '/admin/hyper/websites',
      componentClass: Link,
      text: 'All Websites',
    },
    papertrail: {
      icon: 'folder-open',
      to: '/admin/hyper/papertrail',
      componentClass: Link,
      text: 'Papertrail',
    },
    integrations: {
      icon: 'power-in-unit',
      to: '/admin/hyper/integrations',
      componentClass: Link,
      text: 'Integrations',
    },
    back: {
      icon: 'back',
      text: 'Return',
      to: '/admin',
      pull: 'bottom',
      componentClass: Link,
    },
  };

  const navbar = (
    <Navbar>
      {Object.keys(items).map(key => (
        <Navbar.Item
          key={key}
          {...items[key]}
          active={activeItem === key}
        />
      ))}
    </Navbar>
  );

  return (
    <AdminLayout
      header={header}
      navbar={navbar}
    >
      {children}
    </AdminLayout>
  );
};

Hyper.propTypes = propTypes;
Hyper.defaultProps = defaultProps;

export default Hyper;
